// useDirtyClose — the W4.2 §4.2 modal dirty guard: a stray backdrop-tap / X
// must not silently discard typed work. Callers build a snapshot string from
// every form field (all seeding synchronously, so the mount-time baseline is
// a false-positive-free dirty flag) and call the returned attemptClose from
// the backdrop, the X and the Cancel button.
//
// The same baseline + confirm + close block was open-coded per modal
// (FertApplications, MySprayTasks, …) — import this instead of forking it.

import { useRef } from 'react'
import { confirmDialog } from '@/components/Dialogs'

export function useDirtyClose(snapshot: string, onClose: () => void): () => Promise<void> {
  const baseline = useRef(snapshot)
  return async function attemptClose() {
    if (snapshot !== baseline.current && !(await confirmDialog({
      title:   'Discard changes?',
      message: 'Your unsaved edits will be lost.',
      confirm: 'Discard',
      cancel:  'Keep editing',
      tone:    'danger',
    }))) return
    onClose()
  }
}
